var path = 'scripts/views/directives/transaction-row-lock-status-tooltip.html';
var html = "<div class=\"partially-locked-tooltip\">\n    <p translate>lockStatus.transactionPartiallyLockedTooltip</p>\n\n    <table class=\"text-left\">\n        <tr ng-repeat=\"setting in $ctrl.partialLockSettings track by setting.label\">\n            <td class=\"prl nowrap\" translate>{{ 'lockStatus.label.' + setting.label }}:</td>\n            <td class=\"em-default\" translate>{{ 'lockStatus.value.' + setting.value }}</td>\n        </tr>\n    </table>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/directives/transaction-row-lock-status-tooltip.html
// module id = 388
// module chunks = 0